import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "./store";
import TokenData from "../../models/user/TokenData";
import { UserInfo } from "../../models";
import { TenantModel } from "../../data/entities";

interface AuthenticationState {
  userToken: string | null;
  userInfo: UserInfo | null;
  tokenData: TokenData | null;
  isSignedIn: boolean;
  tenantId?: number | null;
  tenants: TenantModel[];
}

const initialState: AuthenticationState = {
  userToken: null,
  userInfo: null,
  tokenData: null,
  isSignedIn: false,
  tenantId: null,
  tenants: []
};

const authenticationSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.userToken = action.payload;
    },
    clearToken: (state) => {
      state.userToken = null;
    },
    setTokenData: (state, action) => {
      state.tokenData = action.payload;
    },
    clearTokenData: (state) => {
      state.tokenData = null;
    },
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
    clearUserInfo: (state) => {
      state.userInfo = null;
    },
    setIsLoggedIn: (state, action) => {
      state.isSignedIn = action.payload;
    },
    setTenantId: (state, action) => {
      state.tenantId = action.payload;
    },
    setUserTenants: (state, action) => {
      state.tenants = action.payload;
    }
  },
});

export const {
  setToken, clearToken,
  setTokenData, clearTokenData,
  setUserInfo, clearUserInfo,
  setIsLoggedIn, setTenantId,
  setUserTenants
} = authenticationSlice.actions;
export const getUserToken = () => (state: RootState) => state.authentication.userToken;
export const getUserTenantId = () => (state: RootState) => state.authentication.tenantId;
export const getUserInfo = () => (state: RootState) => state.authentication.userInfo;
export const getUserRoles = () => (state: RootState) => state.authentication.userInfo?.roles ?? [];
export const isSysAdmin = () => (state: RootState) =>  state.authentication.userInfo?.roles?.some(role =>role.roleId === 1);
export const isTenantAdmin = () => (state: RootState) =>  state.authentication.userInfo?.roles?.some(role =>role.roleId === 2); 
export const isOrganizationAdmin = () => (state: RootState) =>  state.authentication.userInfo?.roles?.some(role =>role.roleId === 3);
export const isLocationAdmin = () => (state: RootState) =>  state.authentication.userInfo?.roles?.some(role =>role.roleId === 4);
export default authenticationSlice.reducer;

